module.exports = __webpack_public_path__ + "img/icon59.611c1b47.png";